import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * BCP-47 tag for Intl — internal ids 'enUS'/'zhCN' are not valid Intl tags.
 */
export const intlLocale = (): string => {
  const locale = typeof localStorage !== 'undefined' ? localStorage.getItem('locale') : null
  if (locale === 'zhCN') return 'zh-CN'
  if (locale === 'enUS') return 'en-US'
  return locale ?? 'en-US'
}

/**
 * Money from integer cents. The currency ALWAYS comes from data/conf (CNY on
 * .cn, USD/EUR elsewhere); when no currency is known yet the amount renders
 * without a symbol — no page ever hardcodes one.
 */
export const formatMoney = (cents: number | null | undefined, currency?: string): string => {
  if (cents == null || !Number.isFinite(cents)) return '—'
  const value = cents / 100
  if (!currency) {
    return new Intl.NumberFormat(intlLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
  }
  try {
    return new Intl.NumberFormat(intlLocale(), {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  } catch {
    // Unknown/invalid ISO code — fall back to an explicit code suffix.
    return `${value.toFixed(2)} ${currency}`
  }
}
